import RandomSponsors from '@shared/RandomSponsors';

const App = ({ options }) => <RandomSponsors {...options} />;

export default App;
